import elLocale from 'element-ui/lib/locale/lang/es';

export default {
	// Textos internos de Element UI (message box, tablas, formularios, ...)
	el: elLocale.el,

	common: {
		loading: 'Cargando...',
		error: 'Error',
		warning: 'Atención',
		ok: 'Aceptar',
		cancel: 'Cancelar',
		close: 'Cerrar',
		save: 'Guardar',
		saving: 'Guardando...',
		add: 'Añadir',
		adding: 'Añadiendo...',
		create: 'Crear',
		creating: 'Creando...',
		delete: 'Eliminar',
		deleting: 'Eliminando...',
		invite: 'Invitar',
		inviting: 'Invitando...',
		send: 'Enviar',
		sending: 'Enviando...',
		reset: 'Restablecer',
		previous: 'Anterior',
		next: 'Siguiente',
		select: 'Seleccionar',
		or: 'O',
		name: 'Nombre',
		description: 'Descripción',
		email: 'Correo electrónico',
		password: 'Contraseña',
		firstName: 'Nombre',
		lastName: 'Apellido',
		actions: 'Acciones',
		status: 'Estado',
		signIn: 'Iniciar sesión',
	},

	nav: {
		dashboard: 'Panel',
		whiteLabel: 'Marca blanca',
		teams: 'Equipos',
		users: 'Usuarios',
		update: 'Actualizar',
		welcome: 'Bienvenido',
		signIn: 'Iniciar sesión',
		signUpTo: 'Crea tu cuenta en',
		stripePlayground: 'Stripe Playground',
	},

	main: {
		expandMenu: 'Expandir el menú',
		collapseMenu: 'Contraer el menú',
		helpTooltip: 'Ponte en contacto con el equipo de soporte para pedir ayuda o dejarnos tu comentario',
		helpAndFeedback: 'Ayuda y comentarios',
		greeting: '¡Hola {name}!',
		profile: 'Perfil',
		billing: 'Facturación',
		logout: 'Cerrar sesión',
		downloadInstallers: 'Descargar instaladores',
		licenseProblem: 'Problema con la licencia',
		licenseProblemText:
			'Tu suscripción ha sido cancelada, ha caducado o tiene un problema. Entra en el Portal de Facturación para resolverlo.',
		noPaymentMethod: 'No hay un método de pago asociado',
		noPaymentMethodText:
			'Añade una tarjeta de débito o crédito en el portal de facturación para seguir usando el plan Enterprise cuando termine la prueba.',
		goToBillingPortal: 'Ir al Portal de Facturación',
		trialPeriod: 'Período de prueba',
		trialEnds: 'Tu período de prueba termina {when}',
		loadingPleaseWait: 'Cargando, espera un momento...',
		loadingBillingPortal: 'Cargando el portal de facturación...',
		workspaceError: 'Hubo un problema al cargar tu espacio de trabajo. Por favor, inicia sesión de nuevo.',
		redirecting: 'Redirigiendo a tu organización...',
	},

	welcome: {
		privacyPolicy: 'Política de privacidad',
		termsOfUse: 'Términos de uso',
		emailPromptTitle: 'Invitación por correo electrónico',
		emailPromptMessage: 'Confirma tu dirección de correo electrónico',
		invalidEmail: 'Correo electrónico no válido',
	},

	organization: {
		enterprise: 'Enterprise',
		signIn: 'Iniciar sesión',
		signInTo: 'Inicia sesión en {name}',
		enterpriseOnly: 'Solo para empresas con una suscripción Enterprise.',
		yourTeamUrl: 'La URL de tu equipo',
		urlPlaceholder: 'tu-empresa',
		createOrganization: '¿Tu empresa es nueva en Rambox? Crea una organización',
		signUpFree: '¿Eres un usuario particular? Regístrate GRATIS',
	},

	signIn: {
		signInTo: 'Inicia sesión en',
		continueWithGoogle: 'Continuar con Google',
		continueWithFacebook: 'Continuar con Facebook',
		continueWithMicrosoft: 'Continuar con Microsoft',
		emailPlaceholder: 'Correo electrónico',
		passwordPlaceholder: 'Contraseña',
		forgotPassword: '¿Olvidaste tu contraseña?',
		changeOrganization: 'Cambiar de organización',
		authenticating: 'Autenticando...',
		gettingOrganizationInfo: 'Obteniendo los datos de la organización...',
		sendingResetEmail: 'Enviando el correo para restablecer la contraseña...',
		verifyEmail: 'Verifica tu cuenta haciendo clic en el enlace que enviamos a {email} antes de iniciar sesión.',
		providerLinked: '{provider} se vinculó a {email}',
		noTenantId: 'La organización no está configurada correctamente.',
		validation: {
			emailRequired: 'El correo electrónico es obligatorio.',
			emailInvalid: 'Introduce un correo electrónico válido.',
			passwordRequired: 'La contraseña es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
		},
		resetPrompt: {
			title: 'Recuperar contraseña',
			message: 'Introduce tu correo electrónico.',
			invalidEmail: 'El formato del correo electrónico no es válido.',
			sent: 'Hemos enviado un correo para restablecer la contraseña a {email}',
		},
	},

	signUp: {
		signUpTo: 'Crea tu cuenta en',
		userCreated: '¡Tu usuario ha sido creado!',
		validation: {
			firstNameRequired: 'Introduce tu nombre',
			lastNameRequired: 'Introduce tu apellido',
			passwordRequired: 'La contraseña es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
			confirmRequired: 'La confirmación es obligatoria.',
			passwordsDoNotMatch: '¡Las contraseñas no coinciden!',
		},
		confirm: 'Confirmar',
	},

	create: {
		steps: {
			company: 'Datos de la empresa',
			personal: 'Tus datos',
			password: 'Contraseña',
			summary: 'Resumen',
		},
		intro:
			'Estás a punto de crear una cuenta Enterprise. Este tipo de cuenta es {bold}. Si eres un usuario particular, {link}.',
		introBold: 'solo para empresas',
		introLink: 'regístrate GRATIS aquí',
		companyInfo: 'Introduce los datos de tu empresa.',
		personalInfo: 'Introduce tus datos personales.',
		passwordInfo: 'Introduce la contraseña de tu cuenta de administrador.',
		company: 'Empresa',
		companyPlaceholder: 'El nombre de tu empresa',
		url: 'URL',
		urlPlaceholder: 'dominio-empresa',
		workEmail: 'Correo corporativo',
		workEmailPlaceholder: 'Tu correo corporativo',
		firstNamePlaceholder: 'Nombre',
		lastNamePlaceholder: 'Apellido',
		confirm: 'Confirmar',
		companyName: 'Nombre de la empresa',
		companyUrl: 'URL de la empresa',
		adminFirstName: 'Nombre del administrador',
		adminLastName: 'Apellido del administrador',
		adminEmail: 'Correo del administrador',
		adminPassword: 'Contraseña del administrador',
		createButton: '¡Crear!',
		selectTeam: 'Elegir equipo',
		creating: 'Creando tu organización. Espera un momento...',
		validation: {
			firstNameRequired: 'El nombre es obligatorio.',
			lastNameRequired: 'El apellido es obligatorio.',
			emailRequired: 'Introduce una dirección de correo electrónico',
			companyNameRequired: 'Introduce el nombre de tu empresa',
			urlRequired: 'Introduce la URL que quieras usar',
			urlTaken: 'Esta URL ya está en uso',
			urlForbidden: 'Esta URL no está permitida',
			minLength4: 'La longitud mínima es 4.',
			maxLength20: 'La longitud máxima es 20.',
			urlFormat: 'La URL debe empezar con una letra y contener solo letras, números y guiones',
			passwordRequired: 'La contraseña es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
			confirmRequired: 'La confirmación es obligatoria.',
			passwordsDoNotMatch: '¡Las contraseñas no coinciden!',
			workEmailInvalid: 'Introduce un correo corporativo válido',
			notCompanyEmail: 'Se requiere un correo corporativo: {email} no es un correo de empresa',
			disposableEmail: 'Correo temporal detectado: {email} no está permitido',
		},
	},

	gettingStarted: {
		welcomeTo: 'Bienvenido a',
		downloadToStart: 'Descarga Rambox para empezar',
		selectOs: 'Elige tu sistema operativo para descargar el instalador.',
		doubleClick: 'Para empezar la instalación, haz doble clic en el archivo descargado.',
		enterpriseHint:
			'Cuando abras Rambox, recuerda elegir la opción de inicio de sesión Enterprise e introducir la siguiente URL de dominio:',
		downloadInstaller: 'Descargar el instalador',
		gettingOrganizationInfo: 'Obteniendo los datos de la organización...',
	},

	dashboard: {
		// Quien lo lee ya tiene Teams: lo invita a pasarse a v3, no le vende Teams. La bajada y las features
		// salen de textos ya publicados de v3 (asistente de migración de la consola, tour "Novedades" del desktop).
		v3: {
			title: 'Llegó Rambox 3',
			lead:
				'Reconstruimos Rambox desde cero. Tus áreas y roles pasan a ser equipos y subequipos, y nadie pierde su sesión. Toma un minuto y se hace una sola vez, para todos.',
			plus: 'Todo lo que ya usas hoy, y además:',
			groups: {
				team: 'Para tu equipo',
				admins: 'Para administradores',
			},
			features: {
				search: 'Búsqueda unificada en sus apps',
				ai: 'Asistentes de IA en un panel lateral',
				focus: 'Sesiones de enfoque',
				permissions: 'Permisos por equipo y subequipo',
				memberPermissions: 'Permisos propios por miembro',
				theme: 'Un tema con los colores de tu marca',
			},
			migrate: 'Migrar a v3',
			demo: 'Solicitar una demo',
		},
		totalUsers: 'Usuarios totales',
		pendingInvitations: 'Invitaciones pendientes',
		nextInvoiceDate: 'Fecha de la próxima factura',
		nextInvoice: 'Próxima factura',
	},

	teams: {
		selectTeamHint: 'Elige un equipo',
		workspacesFrom: 'Espacios de trabajo del equipo "{name}"',
		popoverTitle: '¿Qué son los equipos y los espacios de trabajo?',
		popoverContent:
			'Un espacio de trabajo es un conjunto de aplicaciones organizadas en grupos que puedes asignar a los usuarios para que las usen dentro de Rambox. Un equipo es un conjunto de espacios de trabajo, para organizarlos mejor. Ej: "RRHH" puede ser un equipo y "Selección" un espacio de trabajo.',
		team: 'Equipo',
		workspace: 'Espacio de trabajo',
		editGroup: 'Editar el grupo',
		deleteGroup: 'Eliminar el grupo',
		viewWorkspace: 'Ver el espacio de trabajo',
		editWorkspace: 'Editar el espacio de trabajo',
		deleteWorkspace: 'Eliminar el espacio de trabajo',
		newTeam: 'Nuevo equipo',
		editTeam: 'Editar el equipo',
		newWorkspace: 'Nuevo espacio de trabajo',
		editWorkspaceTitle: 'Editar el espacio de trabajo',
		newFallback: 'Nuevo',
		validation: {
			nameRequired: 'Introduce un nombre',
			nameTaken: 'Este nombre ya está en uso',
			descriptionRequired: 'Introduce una descripción',
		},
		groupCreated: '¡Grupo creado correctamente!',
		groupEdited: '¡Grupo editado correctamente!',
		groupDeleted: '¡Grupo eliminado correctamente!',
		workspaceAdded: 'Se ha añadido el espacio de trabajo a {name}',
		workspaceEdited: '¡Espacio de trabajo editado correctamente!',
		workspaceDeleted: '¡Espacio de trabajo eliminado correctamente!',
		usersInGroup: 'Hay usuarios en este grupo. Muévelos a otro grupo y después elimina este.',
		usersWithWorkspace: 'Hay usuarios con este espacio de trabajo. Asígnales otro y después elimina este.',
		deleteGroupConfirm: 'Esto eliminará permanentemente "{name}" y todos sus espacios de trabajo. ¿Continuar?',
		deleteWorkspaceConfirm: 'Esto eliminará permanentemente el espacio de trabajo "{name}". ¿Continuar?',
		deleteWorkspaceSimple: 'Esto eliminará el espacio de trabajo. ¿Continuar?',
	},

	users: {
		popoverTitle: 'Invita a tus compañeros',
		popoverContent:
			'Puedes darles permiso para añadir o no nuevos grupos y aplicaciones en Rambox, y clasificarlos en grupos y subgrupos para organizarlos mejor.',
		team: 'Equipo',
		workspace: 'Espacio de trabajo',
		permission: 'Permiso',
		viewWorkspace: 'Ver el espacio de trabajo',
		editUser: 'Editar el usuario',
		resendInvitation: 'Reenviar la invitación',
		deleteThisUser: 'Eliminar este usuario',
		newUser: 'Nuevo usuario',
		editUserTitle: 'Editar usuario',
		permissionsTitle: 'Tipos de permiso',
		permissionsContent:
			'Completo: el usuario podrá crear el espacio de trabajo sin restricciones. Intermedio: hereda la configuración del espacio de trabajo pero puede añadir nuevos grupos y aplicaciones. Básico: solo usa las aplicaciones configuradas en el espacio de trabajo.',
		permissions: {
			full: 'Completo',
			intermediate: 'Intermedio',
			basic: 'Básico',
		},
		admin: 'Administrador',
		adminOf: 'Administrador de {name}',
		support: 'Soporte',
		showSection: 'mostrar la sección',
		notShowSection: 'NO mostrar la sección',
		tags: {
			admin: 'ADMIN',
			pending: 'PENDIENTE',
			active: 'ACTIVO',
			inactive: 'INACTIVO',
		},
		validation: {
			emailRequired: 'Introduce una dirección de correo electrónico',
			emailInvalid: 'Introduce un correo electrónico válido',
			emailTaken: 'Este correo electrónico ya está en uso',
			firstNameRequired: 'Introduce el nombre',
			lastNameRequired: 'Introduce el apellido',
			permissionRequired: 'Elige un permiso',
			teamRequired: 'Elige un equipo',
			workspaceRequired: 'Elige un espacio de trabajo',
		},
		emailSent: '¡Correo enviado correctamente!',
		userEdited: 'Usuario editado',
		deleteCompleted: 'Eliminación completada',
		resendTitle: 'Reenviar la invitación',
		resendMessage: 'Esto reenviará la invitación por correo electrónico. ¿Continuar?',
		deleteUserTitle: 'Eliminar usuario',
		deleteInvitationTitle: 'Eliminar invitación',
		deleteUserConfirm: 'Esto eliminará permanentemente a "{name}" y todo su espacio de trabajo. ¿Continuar?',
		deleteInvitationConfirm: 'Esto eliminará la invitación de "{email}". ¿Continuar?',
		basicPermissionWarning: 'Cambiar el permiso a "Básico" eliminará el espacio de trabajo del usuario. ¿Continuar?',
	},

	whiteLabel: {
		popoverTitle: '¿Qué puedo hacer aquí?',
		popoverContent:
			'Aquí podrás personalizar la aplicación de Rambox y el panel para que usen los colores y el logotipo de tu empresa.',
		settings: 'Ajustes',
		organizationName: 'Nombre de la organización',
		namePlaceholder: 'Nombre',
		logo: 'Logotipo',
		setToDefault: 'Restaurar el valor por defecto',
		customizeLayout: 'Personaliza el diseño con tus colores',
		light: 'Claro',
		dark: 'Oscuro',
		primary: 'Principal',
		backgroundColor: 'Color de fondo',
		titlebar: 'Barra de título',
		saveConfirmTitle: 'Guardar los cambios',
		saveConfirmMessage: 'Esto sobrescribirá permanentemente tu configuración anterior. ¿Continuar?',
		saved: 'Configuración guardada correctamente',
	},

	workspaces: {
		title: 'Configuración del espacio de trabajo',
		addGroup: 'Añadir grupo',
		addApp: 'Añadir aplicación',
		addNewGroup: 'Añadir un grupo nuevo',
		addNewApp: 'Añadir una aplicación nueva',
		editApp: 'Editar la aplicación',
		editGroup: 'Editar el grupo',
		deleteApp: 'Eliminar la aplicación',
		deleteGroup: 'Eliminar el grupo',
		configurationRequired: 'Falta configurarlo',
		workspaceTag: 'ESPACIO DE TRABAJO',
		affectsUsers: 'Este cambio afectará a todos los usuarios que usan este espacio de trabajo.',
		deleteGroupConfirm: 'Esto eliminará permanentemente el grupo "{name}" y todas sus aplicaciones. ¿Continuar?',
		deleteAppConfirm: 'Esto eliminará permanentemente la aplicación "{name}". ¿Continuar?',
		deleteAppTitle: 'Eliminar aplicación',
		deleteGroupTitle: 'Eliminar grupo',
		deleteCompleted: 'Eliminación completada',
	},

	appConfig: {
		newApp: 'Nueva aplicación',
		editApp: 'Editar la aplicación',
		roleWarning: 'Este cambio afectará a todos los usuarios de este rol.',
		step1: 'Paso 1',
		step2: 'Paso 2',
		editIcon: 'Editar',
		setDefaultIcon: 'Restaurar el valor por defecto',
		visitWebsite: 'Visitar el sitio web',
		url: 'URL',
		urlOption: 'Opción {index}',
		profile: 'Perfil',
		linkHandling: 'Gestión de enlaces',
		advanced: 'Avanzado',
		advancedWarning:
			'Las siguientes opciones pueden causar problemas de seguridad, úsalas con responsabilidad. Para aplicar cualquiera de ellas, debes reiniciar la aplicación.',
		injectJs: 'Inyectar código JavaScript',
		injectCss: 'Inyectar código CSS',
		pleaseInput: 'Introduce un valor',
		userAgent: 'User Agent',
		hibernate: 'Hibernación',
		after: 'Después de',
		minutes: 'minutos',
		hibernateHint: 'Déjalo en 0 para desactivar esta función',
		startHibernated: 'Iniciar hibernada',
		proxy: 'Proxy',
		type: 'Tipo',
		needsRelaunch: '(requiere reiniciar)',
		host: 'Host',
		hostPlaceholder: 'URL o IP',
		port: 'Puerto',
		username: 'Usuario',
		forceMobile: 'Forzar la versión móvil',
		validation: {
			nameRequired: 'Introduce el nombre de la aplicación',
			urlInvalid: 'Introduce una URL válida',
			urlValid: 'Introduce una URL válida',
			valueRequired: 'Introduce un valor',
		},
		appEdited: 'Aplicación editada',
		appCreated: 'Aplicación creada',
	},

	appList: {
		customApp: 'Aplicación personalizada',
		search: 'Buscar...',
		noResults:
			'No hay aplicaciones que coincidan con tu búsqueda, ¡pero puedes añadirla con la opción "Aplicación personalizada" de arriba!',
	},

	groupConfig: {
		newGroup: 'Nuevo grupo',
		editGroup: 'Editar el grupo',
		sharedHint: 'Este grupo se añadirá al espacio de trabajo del usuario. Para compartirlo, usa la sección Equipos',
		affectsUsers: 'Este cambio afectará a todos los usuarios que comparten este espacio de trabajo.',
		namePlaceholder: 'Ejemplo: Personal, Trabajo, Mensajería, Correo...',
		selectIcon: 'Elige un icono',
		profile: 'Perfil',
		validation: {
			titleRequired: 'Introduce un título',
		},
		groupEdited: 'Grupo editado',
		groupCreated: 'Grupo creado',
	},

	profile: {
		title: 'Perfil',
		changePassword: 'Cambiar la contraseña',
		changePasswordTitle: 'Cambiar la contraseña',
		currentPassword: 'Contraseña actual',
		newPassword: 'Contraseña nueva',
		confirmNewPassword: 'Confirma la contraseña nueva',
		validation: {
			firstNameRequired: 'El nombre es obligatorio.',
			lastNameRequired: 'El apellido es obligatorio.',
			emailRequired: 'Introduce una dirección de correo electrónico',
			emailInvalid: 'Introduce un correo electrónico válido',
			currentPasswordRequired: 'La contraseña actual es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
			newPasswordRequired: 'La contraseña nueva es obligatoria.',
			confirmNewRequired: 'La confirmación de la contraseña nueva es obligatoria.',
			newPasswordsDoNotMatch: '¡Las contraseñas nuevas no coinciden!',
		},
		userEdited: 'Usuario editado',
		passwordChanged: 'Contraseña cambiada correctamente',
	},

	themePreviewer: {
		editGmail: 'Editar Gmail',
	},

	update: {
		outdated: 'Estás usando una versión desactualizada, actualízala...',
		goToMenu: 'Ve a Menú, Ayuda, Acerca de Rambox y actualiza a la última versión',
		orDownload: 'o descarga el instalador desde rambox.app',
	},

	store: {
		emailInvitationError: 'Algo ha salido mal al enviar la invitación por correo electrónico',
	},

	// Códigos de error de Firebase. Los que no estén aquí muestran el mensaje
	// original devuelto por Firebase.
	firebase: {
		'auth/invalid-email': 'El correo electrónico no es válido.',
		'auth/user-disabled': 'Esta cuenta ha sido deshabilitada. Ponte en contacto con soporte.',
		'auth/user-not-found': 'No existe ninguna cuenta con este correo electrónico.',
		'auth/wrong-password': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/invalid-credential': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/invalid-login-credentials': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/missing-password': 'Introduce tu contraseña.',
		'auth/email-already-in-use': 'Ya existe una cuenta con este correo electrónico.',
		'auth/weak-password': 'La contraseña es demasiado débil. Usa al menos 6 caracteres.',
		'auth/operation-not-allowed': 'Este método de inicio de sesión no está habilitado.',
		'auth/too-many-requests': 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
		'auth/network-request-failed': 'Error de conexión. Revisa tu conexión a internet e inténtalo de nuevo.',
		'auth/popup-closed-by-user': 'Se cerró la ventana de inicio de sesión antes de terminar.',
		'auth/cancelled-popup-request': 'Se canceló el inicio de sesión.',
		'auth/requires-recent-login': 'Inicia sesión de nuevo para completar esta acción.',
		'auth/expired-action-code': 'Este enlace ha caducado. Solicita uno nuevo.',
		'auth/invalid-action-code': 'Este enlace no es válido o ya ha sido utilizado.',
		'auth/account-exists-with-different-credential':
			'Ya existe una cuenta con este correo electrónico que usa otro método de inicio de sesión.',
		'auth/internal-error': 'Algo ha salido mal. Inténtalo de nuevo.',
	},
};
